// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_H6I","cls2":"ReferenceEvaluationPage-cls2_LQw ReferenceEvaluationPage-cls1_H6I"};